let forterToken = '';

export const setupForter = () => {
  document.addEventListener('ftr:tokenReady', function (evt) {
    forterToken = evt.detail;
  });
};

export const createForterHeader = () => {
  return { 'ftr-token': forterToken };
};
